import { Col, Container, Row } from "react-bootstrap";

const ServiceTerminatedNotice: React.FC = () => {
    return (
        <Container className=" text-center" style={{ color: "var(--text-primary)", marginTop: "4rem" }}>
            <Row className="justify-content-center">
                <Col xs={12} md={8} lg={6}>
                    <h1 className="font-weight-bold">Palvelusi on irtisanottu!</h1>
                    <p style={{ fontSize: "1.2rem", marginTop: "2rem" }}>
                        <em>Voit käyttää palvelua nykyisen palvelujakson loppuun asti. Tämän jälkeen sinun, seniorin ja läheisten tilit poistuvat käytöstä.</em>
                    </p>
                </Col>
            </Row>
        </Container>
    );
};

const EndSubscription: React.FC = () => {
    return (
        <div className="m-auto">
            <ServiceTerminatedNotice />
        </div>
    );
};

export default EndSubscription;
